import { useDecision } from '@optimizely/react-sdk'
import { useSelector } from 'react-redux'

import { useGoustoAnytimeMenuVariant } from 'routes/Menu/experiments/GoustoAnytime/useGoustoAnytimeMenuVariant'
import { getBasketOrderDetails } from 'selectors/basket'
import { getUserSubscriptionState } from 'selectors/user'

const GOUSTO_ANYTIME_FLAG = 'tomatoes_ofx_webclient_gousto_anytime'

type OrderDetailsImmutable = { get: (key: 'orderType') => string | undefined }

export const useShowGoustoAnytimeOrderConfirmationBanner = (): boolean => {
  const [decision] = useDecision(GOUSTO_ANYTIME_FLAG)
  // Read the order type off the order loaded on the confirmation page (fetched by
  // id from the URL), not from user.orders: the just-created order isn't in
  // user.orders until a reload, so that lookup is empty on the checkout redirect.
  const orderDetails = useSelector(getBasketOrderDetails) as
    | OrderDetailsImmutable
    | false
    | undefined
  const subscriptionState = useSelector(getUserSubscriptionState) as string | undefined
  const isInMenuExperienceVariant = useGoustoAnytimeMenuVariant()

  const isTransactional = !!orderDetails && orderDetails.get('orderType') === 'transactional'
  const hasActiveSubscription = subscriptionState === 'active'

  return decision.enabled && isTransactional && isInMenuExperienceVariant && !hasActiveSubscription
}
